<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      USUARIOS
    </p>

    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ usuarios.length }} Usuario (s)</v-toolbar-title
        >

        <v-spacer></v-spacer>

        <v-btn depressed color="primary" @click="addUsuarioDialog = true">
          <v-icon left dark> mdi-plus </v-icon>
          Agregar Usuario
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="usuarios.length > 0" two-line subheader>
              <v-list-item v-for="item in usuarios" :key="item.user_id">
                <v-list-item-content>
                  <v-list-item-title
                    >{{ item.name }} - {{ item.email }}</v-list-item-title
                  >
                  <v-list-item-subtitle>
                    <p class="mb-0" style="line-height: 20px">
                      {{ item.user_metadata.rol.Name.es }}
                    </p>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <!-- <v-list-item @click="openDialogEditPublication(item)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="blue-grey">mdi-pencil-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>-->
                      <v-list-item @click="deleteUsuario(item.user_id)">
                        <v-list-item-icon class="mr-3">
                          <v-icon color="red">mdi-delete-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Eliminar</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay usuarios registrador, !Registra uno!
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addUsuarioDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar Usuario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="cancelDialogAddUsuario()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-3">
          <v-container>
            <v-form ref="formAddUsuario">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="newUsuario.Name"
                    label="Nombre"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newUsuario.Email"
                    label="Email"
                    outlined
                    hide-details="auto"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newUsuario.Password"
                    label="Password"
                    outlined
                    hide-details="auto"
                    required
                    type="password"
                    :rules="passwordRules"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="newUsuario.Rol"
                    :items="roles"
                    item-text="Name.es"
                    label="Rol"
                    outlined
                    return-object
                    single-line
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="cancelDialogAddUsuario()"
            >Cancelar</v-btn
          >
          <v-btn text @click="addUsuario(newUsuario)" large>Guardar</v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" :value="loadingAddUsuario">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >

    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import api from "@/api/users-api";

export default {
  name: "Home",
  data() {
    return {
      addUsuarioDialog: false,
      loadingAddUsuario: false,
      usuarios: [],
      newUsuario: {
        Name: null,
        Email: null,
        Password: null,
        Rol: null,
      },
      roles: [
        {
          Id: "admin",
          Name: {
            es: "Administrador",
          },
        },
        {
          Id: "editor",
          Name: {
            es: "Editor",
          },
        },
      ],
      rules: [(v) => !!v || "Este campo es requerido"],
      passwordRules: [
        (v) => !!v || "Este campo es requerido",
        (v) =>
          (v && v.length >= 8) ||
          "La contraseña debe tener al menos 8 caracteres",
        (v) =>
          /(?=.*[A-Z])/.test(v) ||
          "La contraseña debe tener al menos una mayuscula",
        (v) =>
          /(?=.*\d)/.test(v) || "La contraseña debe tener al menos un numero",
      ],
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {
    this.getUsuarios();
  },
  methods: {
    async getUsuarios() {
      try {
        const data = await api.getUsers();
        if (data) {
          this.usuarios = data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    cancelDialogAddUsuario() {
      this.addUsuarioDialog = false;
    },
    async addUsuario(newUsuario) {
      if (this.$refs.formAddUsuario.validate()) {
        this.loadingAddUsuario = true;
        const data = await api.addUser(newUsuario);
        if (data.name != "Error") {
          this.loadingAddUsuario = false;
          this.addUsuarioDialog = false;
          this.$refs.formAddUsuario.reset();

          this.showSnackbar("Se registro un nuevo usuario correctamente", "success")

          this.newUsuario = {
            Name: null,
            Email: null,
            Password: null,
            Rol: null,
          };
          this.getUsuarios();
        } else {
          this.loadingAddUsuario = false;
          this.addUsuarioDialog = false;
          this.$refs.formAddUsuario.reset();
          this.newUsuario = {
            Name: null,
            Email: null,
            Password: null,
            Rol: null,
          };
          this.showSnackbar("Ocurrio un error durante el registro del nuevo usuario", "error")
        }
      }
    },
    async deleteUsuario(userId) {
      await api.deleteUser(userId);
      this.showSnackbar("Se eliminó correctamente el usuario", "success");
      this.getUsuarios();
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>